module.exports = "<p>\n  category-start works!\n</p>\n"